{"id":"ProductDetail","prefabs":{"default":{"children":[{"component":"ProductDetail","options":"options:*"}]}}}